import React from "react";

interface IFieldError {
  text: any;
}

export default function FieldError({ text }: IFieldError) {
  return   <div className="d-flex justify-content-start text-red-500 text-xs">{text}</div>;

}
